import { ReactNode } from 'react';

import PageLayout, {
	PageLayoutInsetContent,
} from 'components/standard/PageLayout';
import { useNavTitle } from 'containers/LeftHandLayout';
import { useParams } from 'react-router-dom';

export interface DomainDetailsLayoutProps {
	children: ReactNode;
}

const DomainDetailsLayout = ({ children }: DomainDetailsLayoutProps) => {
	const { domain } = useParams<{ domain: string }>();
	useNavTitle('Domain details');

	return (
		<PageLayout
			variant="dynamic"
			// TODO DEV-6088 remoe the "SSL - "
			title={`SSL - ${domain}`}
		>
			{/* TODO DEV-6088 add the tabs navigation here */}
			<PageLayoutInsetContent sx={{ flexGrow: 1 }}>
				{children}
			</PageLayoutInsetContent>
		</PageLayout>
	);
};

export default DomainDetailsLayout;
